import { useRouteError } from "react-router";
import { AppErrorFallback } from "./AppErrorFallback";

export function RootErrorBoundary() {
  const routeError = useRouteError();
  return <AppErrorFallback error={routeError} />;
}
